import { render, staticRenderFns } from "./BrandConnectedSePayVersion2.vue?vue&type=template&id=1774628b&scoped=true"
import script from "./BrandConnectedSePayVersion2.vue?vue&type=script&lang=js"
export * from "./BrandConnectedSePayVersion2.vue?vue&type=script&lang=js"
import style0 from "./BrandConnectedSePayVersion2.vue?vue&type=style&index=0&id=1774628b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1774628b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1774628b')) {
      api.createRecord('1774628b', component.options)
    } else {
      api.reload('1774628b', component.options)
    }
    module.hot.accept("./BrandConnectedSePayVersion2.vue?vue&type=template&id=1774628b&scoped=true", function () {
      api.rerender('1774628b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/BrandConnectedSePayVersion2.vue"
export default component.exports